/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AddressSuggestions200Response } from '../model/models';
import { AddressSuggestions500Response } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface AddressServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Address suggestions
     * 
     * @param query 
     */
    addressSuggestions(query?: string, extraHttpRequestParams?: any): Observable<AddressSuggestions200Response>;

}
